import React from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function SiteNav() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const navClass = ({ isActive }) =>
    `font-ui text-[0.72rem] uppercase tracking-[0.22em] pb-1 transition-colors ${
      isActive ? "text-[#1A1A1A] border-b border-[#1A1A1A]" : "text-[#5C554E] hover:text-[#1A1A1A]"
    }`;

  return (
    <header className="border-b border-[#D9D2C7] bg-[#F2EBDC]" data-testid="site-nav">
      <div className="max-w-6xl mx-auto px-6 lg:px-10 py-6 flex flex-col items-center gap-3">
        <Link
          to="/"
          className="font-display text-3xl tracking-tight text-[#1A1A1A]"
          data-testid="site-logo"
        >
          Adrian's Blog
          <span className="text-[#C45543]">.</span>
        </Link>
        <p className="overline" data-testid="site-tagline">
          A Personal Library of Stories &amp; Poems
        </p>
        <nav className="mt-2 flex flex-wrap items-center gap-7" data-testid="site-nav-links">
          <NavLink to="/" end className={navClass} data-testid="nav-home">
            Reading Room
          </NavLink>
          <NavLink to="/stories" className={navClass} data-testid="nav-stories">
            Stories
          </NavLink>
          <NavLink to="/poems" className={navClass} data-testid="nav-poems">
            Poems
          </NavLink>
          <NavLink to="/about" className={navClass} data-testid="nav-about">
            About
          </NavLink>
          {user ? (
            <>
              <NavLink to="/admin" className={navClass} data-testid="nav-admin">
                Desk
              </NavLink>
              <button
                onClick={() => {
                  logout();
                  navigate("/");
                }}
                className="btn-link"
                data-testid="nav-logout"
              >
                Sign Out
              </button>
            </>
          ) : (
            <NavLink to="/login" className={navClass} data-testid="nav-login">
              Sign In
            </NavLink>
          )}
        </nav>
      </div>
    </header>
  );
}
